import { Button } from 'components/atoms';
import { t } from 'i18next';
import { PiFunnel } from 'react-icons/pi';
import {
  BUTTON_VARIANT,
  IButtonProps,
} from 'types/components/button/button.interface';
import { II18nextPrefix } from 'types/components/components.interface';

interface IFormButtonFilterProps extends IButtonProps, II18nextPrefix {}

const FormButtonFilter = ({
  i18nextPrefix,
  ...props
}: IFormButtonFilterProps) => {
  return (
    <Button variant={BUTTON_VARIANT.submit} onlyIcon {...props}>
      <Button.Icon icon={<PiFunnel />} />
    </Button>
  );
};

export default FormButtonFilter;
